import $ from "jquery";
import loadjs from "shared/util/loadjs";

/*

How this emoji stuff works.
Service JS will call jQueryElement.emojify().
This will check if emojis are natively supported (by checking if a few emoji are rendered properly.)
If they aren't, this will store all the emojifiing elements into a buffer.
hen it'll load emojione from cloudflare.
Once that's loaded, it'll emojify all the shit in the buffer, then clear the buffer.

*/

// LOCAL STATE
// -------------------

const _caches = {
	emojify: [],
	deemojify: [],
	supports: null,
	isLoaded: false,
};


// CONSTS
// -------------------

const v = "2.2.7";
const url = `https://cdnjs.cloudflare.com/ajax/libs/emojione/${v}/lib/js/emojione.min.js`;
const pngPath = `https://cdnjs.cloudflare.com/ajax/libs/emojione/${v}/assets/png/`;

// CHECK FOR SUPPORT
// -------------------

function checkEmojiSupport() {
	if (!document.createElement("canvas").getContext) {
		return false;
	}

	const context = document.createElement("canvas").getContext("2d");

	if (typeof context.fillText !== "function") {
		return false;
	}

	// this should be a fairly recent emoji.
	// to find this out, dump this into a console:
	// "<emoji>".charCodeAt(0) // first code
	// "<emoji>".charCodeAt(1) // second code
	const nauseatedFace = String.fromCharCode(55358) + String.fromCharCode(56610);

	context.textBaseline = "top";
	context.font = "32px Arial";
	context.fillText(nauseatedFace, 0, 0);
	return context.getImageData(16, 16, 1, 1).data[0] !== 0;
}

function supports() {
	if (_caches.supports === null) {
		_caches.supports = checkEmojiSupport();
	}

	return _caches.supports;
}


// GRUNTWORK
// -------------------

function resolveCaches() {
	if (typeof window.emojione !== "undefined") {
		_caches.emojify.forEach((el) => {
			$(el).html(window.emojione.unicodeToImage(el.innerHTML));
		});
		_caches.emojify = [];

		_caches.deemojify.forEach((el) => {
			const str = el.innerHTML;
			const stripped = str.replace(new RegExp(window.emojione.unicodeRegexp, "gi"), "");
			$(el).html(stripped);
		});
		_caches.deemojify = [];
	}
}

function loadFromCDN() {
	if (_caches.isLoaded) {
		resolveCaches();
		return;
	}


	loadjs(
		url,

		// success
		() => {
			// mark as loaded
			_caches.isLoaded = true;

			// set the url for emoji files
			window.emojione.imagePathPNG = pngPath;

			resolveCaches();
		},

		// error
		() => {
			// just make it do nothing
			_caches.supports = true;
		},
	);
}

// EXTERNAL INTERFACES
// -------------------

// Replace emoji chars with images
$.fn.emojify = function jemojify() {
	if (supports()) {
		return;
	}

	this.each((i, el) => _caches.emojify.push(el));

	loadFromCDN();
};

// Remove emoji images and replace with the native chars
$.fn.deEmojify = function jdeEmojify() {
	if (supports()) {
		return;
	}

	this.each((i, el) => _caches.deemojify.push(el));

	loadFromCDN();
};



// WEBPACK FOOTER //
// ./src/shared/modules/AsyncEmoji.js